<style scoped>
.title-dashboard {
  color: #525252;
  font-weight: 500;
}
.table > thead > tr > th {
  white-space: normal;
}
.table > tbody > tr > td {
  white-space: nowrap;
  text-align: center;
}


@media only screen and (max-width: 600px) {
  .col {
    margin-bottom: 0.5rem;
  }
}
p {
  margin: 5px 0;
}
.sd {
  font-size: 1.25rem;
  font-weight: bolder;
}
.total {
  font-size: 2.25rem;
  font-weight: 600;
}
.confirmation {
  font-size: 1rem;
  font-weight: bolder;
}
.bg-primary {
  background-color: #4285f4 !important;
}

.bg-warning {
  background-color: #ffbb33 !important;
}

.bg-success {
  background-color: #00c851 !important;
}

.ms-dashboard {
  text-align: center;
  padding: 0.5rem;
  border: 1px solid #dfe1e5 !important;
  box-shadow: none;
}

.table-sisnerling {
  position: relative;
  width: 100%;
  z-index: 1;
  margin: auto;
  overflow: auto;
  height: calc(100vh - 250px);
}


.table-sisnerling tbody tr th:nth-child(2) {
  min-width: 200px !important;
}
.table-sisnerling table {
  width: 100%;
  min-width: 1280px;
  margin: auto;
  border-collapse: separate;
  border-spacing: 0;
}
.table-wrap {
  position: relative;
}
.table-sisnerling th {
  text-align: center;
}

.table-sisnerling th,
.table-sisnerling td {
  padding: 10px 5px;
  vertical-align: top;
}
.table-sisnerling thead {
  white-space: nowrap;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 4;
}
.table-sisnerling tfoot,
.table-sisnerling tfoot th,
.table-sisnerling tfoot td {
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  z-index: 0;
}

a:focus {
  background: red;
} /* testing links*/
#ms-dashboard{
  background: white;
}
</style>
<template>
  <div id="ms-dashboard" class="content content--borderless">
    <div class="d-flex align-items-center" style="padding:20px 75px;">
      <div>
        <div class="text-18 text-semi-bold">Dashboard</div>
        <div class="text-12 text-600">Selamat Datang di Pelaporan Metadata Statistik, berikut ringkasan pelaporan yang telah dilakukan</div>
      </div>
      <div class="ml-auto">
        <b-dropdown id="dropdown-dropup" text="Drop-Up"  class="m-2" toggle-class="button px-2 button--sm button--outlined text-nowrap">
          <template #button-content>
              <VueFeather type="clock" size="14" stroke-width="2" style="display:nlock"></VueFeather> &nbsp; Periode: <span class="text-bold pl-1">{{submissionPeriod}}</span>
          </template>
          <b-dropdown-item  
            v-for="(period , index) in options.submissionPeriod" :key="index" 
            :active="submissionPeriod == period" 
            @click="submissionPeriodChanged(period)" 
          >
              {{period}}
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <div class="content__body" style="padding:0px 25px 50px 25px">
      <b-row>
        <b-col>
          <div class="card shadow">
            <VueApexCharts type="area" :options="produsenDataSummary.msKegChart.options" :series="produsenDataSummary.msKegChart.series"></VueApexCharts>
          </div>
        </b-col>
        <b-col>
          <div class="card shadow">
            <VueApexCharts type="area" :options="produsenDataSummary.msVarChart.options" :series="produsenDataSummary.msVarChart.series"></VueApexCharts>
          </div>
        </b-col>
        <b-col>
          <div class="card shadow">
            <VueApexCharts type="area" :options="produsenDataSummary.msIndChart.options" :series="produsenDataSummary.msIndChart.series"></VueApexCharts>
          </div>
        </b-col>
      </b-row>
      
      <div class="table-wrapper" style="margin:30px 0 0 0 !important">
        <table class="table table--light table--bordered">
          <thead>
            <tr>
              <th style="vertical-align: middles;" class="text-center w-40" rowspan="2">No.</th>
              <th style="vertical-align: middle;" rowspan="2" class="pl-2">Status</th>
              <th class="text-center">Metadata Statistik Kegiatan</th>
              <th class="text-center">Metadata Statistik Variabel</th>
              <th class="text-center">Metadata Statistik Indikator</th>
            </tr>
          </thead>
          <tbody v-if="produsenDataSummaryByStatus.data && !produsenDataSummaryByStatus.isLoading">
            <tr>
              <td>1</td>
              <td>Draft</td>
              <td>{{produsenDataSummaryByStatus.data.draft_ms_keg}}</td>
              <td>{{produsenDataSummaryByStatus.data.draft_ms_var}}</td>
              <td>{{produsenDataSummaryByStatus.data.draft_ms_ind}}</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Submit</td>
              <td>{{produsenDataSummaryByStatus.data.submitted_ms_keg}}</td>
              <td>{{produsenDataSummaryByStatus.data.submitted_ms_var}}</td>
              <td>{{produsenDataSummaryByStatus.data.submitted_ms_ind}}</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Sedang diperiksa</td>
              <td>{{produsenDataSummaryByStatus.data.under_review_ms_keg}}</td>
              <td>{{produsenDataSummaryByStatus.data.under_review_ms_var}}</td>
              <td>{{produsenDataSummaryByStatus.data.under_review_ms_ind}}</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Perlu perbaikan</td>
              <td>{{produsenDataSummaryByStatus.data.correction_required_ms_keg}}</td>
              <td>{{produsenDataSummaryByStatus.data.correction_required_ms_var}}</td>
              <td>{{produsenDataSummaryByStatus.data.correction_required_ms_ind}}</td>
            </tr>
            <tr>
              <td>5</td>
              <td>Sudah diperbaiki</td>
              <td>{{produsenDataSummaryByStatus.data.revised_ms_keg}}</td>
              <td>{{produsenDataSummaryByStatus.data.revised_ms_var}}</td>
              <td>{{produsenDataSummaryByStatus.data.revised_ms_ind}}</td>
            </tr>
            <tr>
              <td>6</td>
              <td>Ditolak</td>
              <td>{{produsenDataSummaryByStatus.data.rejected_ms_keg}}</td>
              <td>{{produsenDataSummaryByStatus.data.rejected_ms_var}}</td>
              <td>{{produsenDataSummaryByStatus.data.rejected_ms_ind}}</td>
            </tr>
            <tr>
              <td>7</td>
              <td>Diterima</td>
              <td>{{produsenDataSummaryByStatus.data.approved_ms_keg}}</td>
              <td>{{produsenDataSummaryByStatus.data.approved_ms_var}}</td>
              <td>{{produsenDataSummaryByStatus.data.approved_ms_ind}}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5" v-if="produsenDataSummaryByStatus.isLoading">
                <div class="text-primary text-semi-bold d-flex justify-content-center">
                  <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data
                </div>
              </td>
              <td colspan="5" v-else-if="produsenDataSummaryByStatus.error">
                <div class="text-error d-flex justify-content-center">
                  {{produsenDataSummaryByStatus.error}}
                </div>
              </td>
              <td colspan="5" v-else>
                <div class="text-error  d-flex justify-content-center">
                  <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp; Tidak ada data yang tersedia
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/main.scss";
import eselon2 from "./dashboard/eselon2.js";
import msService from "../../services/MsService";
import wilayahService from "../../services/ms/MasterWilayahService";
// import chart from "@/components/Chart";
// import SettingService from "@/services/SettingService";
import VueFeather from 'vue-feather';
import VueApexCharts from 'vue-apexcharts'
// import { error } from 'highcharts';
export default {
  components: {
    // chart,
    VueFeather,
    VueApexCharts
  },
  data: () => {
    return {
      submissionPeriod:null,
      options:{
        province:[],
        city:[],
        submissionPeriod:[]
      },
      produsenDataSummary: {
        data:[],
        msKegChart:{
          series:[{
            name: "Kegiatan",
            type: 'area',
            data: [23, 34, 12, 54, 32 , 43]
          }],
          options: {
            chart: {
              fontFamily: 'Manrope, Helvetica, Arial, sans-serif',
              type: 'area',
              zoom: {
                enabled: false
              }
            },
            dataLabels: {
              enabled: false
            },
            grid: {
              show: false,
            },
            stroke: {
              show: true,
              curve: 'smooth'
            },
            title: {
              text: '0',
              align: 'left',
              offsetY: 20,
              style: {
                fontSize:  '30px',
                fontWeight:  'bold',
              },
            },
            subtitle: {
              text: 'Metadata Statistik Kegiatan',
              align: 'left',
              offsetY: 60,
            },
            yaxis:{
              show: false,
            },
            xaxis: {
              labels: {
                show: false
              },
            },
          },
        },
        msVarChart:{
          series:[{
            name: "Variabel",
            type: 'area',
            data: [23, 34, 12, 54, 32 , 43]
          }],
          options: {
            chart: {
              fontFamily: 'Manrope, Helvetica, Arial, sans-serif',
              type: 'area',
              zoom: {
                enabled: false
              }
            },
            dataLabels: {
              enabled: false
            },
            grid: {
              show: false,
            },
            stroke: {
              show: true,
              curve: 'smooth'
            },
            title: {
              text: '0',
              align: 'left',
              offsetY: 20,
              style: {
                fontSize:  '30px',
                fontWeight:  'bold',
              },
            },
            subtitle: {
              text: 'Metadata Statistik Variabel',
              align: 'left',
              offsetY: 60,
            },
            yaxis:{
              show: false,
            },
            xaxis: {
              labels: {
                show: false
              },
            },
          },
        },
        msIndChart:{
          series:[{
            name: "Kegiatan",
            type: 'area',
            data: [23, 34, 12, 54, 32 , 43]
          }],
          options: {
            chart: {
              fontFamily: 'Manrope, Helvetica, Arial, sans-serif',
              type: 'area',
              zoom: {
                enabled: false
              }
            },
            dataLabels: {
              enabled: false
            },
            grid: {
              show: false,
            },
            stroke: {
              show: true,
              curve: 'smooth'
            },
            title: {
              text: '0',
              align: 'left',
              offsetY: 20,
              style: {
                fontSize:  '30px',
                fontWeight:  'bold',
              },
            },
            subtitle: {
              text: 'Metadata Statistik Indikator',
              align: 'left',
              offsetY: 60,
            },
            yaxis:{
              show: false,
            },
            xaxis: {
              labels: {
                show: false
              },
            },
          },
        },
        isLoading:false,
        error:null,
      },
      produsenDataSummaryByStatus: {
        data:[],
        isLoading:false,
        error:null,
      },
      rekap: {
        total_metadata_statistik_kegiatan: "",
        total_metadata_statistik_indikator: "",
        total_metadata_statistik_variabel: ""
      },
      data: [],
      field: [
        "no",
        {
          key: "organisasi_penanggung_jawab",
          label: "Organisasi Penanggung Jawab",
          thStyle: "minWidth:300px"
        },
        {
          key: "divisi_penanggung_jawab",
          label: "Divisi Penanggung Jawab",
          thStyle: "minWidth:300px"
        },
        "draft",
        "submitted",
        {
          key: "under_review",
          label: "Under Review",
          thStyle: "minWidth:150px"
        },
        {
          key: "correction_required",
          label: "Correction Required",
          thStyle: "minWidth:200px"
        },
        "revised",
        "rejected",
        "approved",
        "published",
        "total"
      ],
      title: "",
      breadcrumbs: [
        {
          text: "Beranda",
          active: true
        }
      ],
      isLoading: true,
      metadataStatistik: [],
      provinsiSelected: null,
      provinsiOptions: [],
      kabupatenKotaSelected: null,
      kabupatenKotaOptions: [],
      dashboardSelected: 1,
      dashboardOptions: [
        {
          value: 1,
          text:
            "Jumlah Metadata Statistik yang berstatus Submitted berdasarkan Jenis Statistik, dan Wilayah"
        },
        {
          value: 2,
          text:
            "Jumlah Metadata Statistik Kegiatan berdasarkan Jenis Statistik, Status, dan Wilayah"
        },
        {
          value: 3,
          text:
            "Jumlah Metadata Statistik Variabel berdasarkan Jenis Statistik, Status, dan Wilayah"
        },
        {
          value: 4,
          text:
            "Jumlah Metadata Statistik Indikator berdasarkan Jenis Statistik, Status, dan Wilayah"
        },
        {
          value: 5,
          text:
            "Jumlah Metadata Statistik Kegiatan yang Berstatus Approved berdasarkan Jenis Statistik, Jenis Metode Pengumpulan Data, dan Wilayah"
        }
      ],
      tahunSelected: 2021,
      chartPieKegOptions: {
        chart: {
          backgroundColor: "transparent",
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie"
        },
        title: {
          verticalAlign: "middle",
          floating: true,
          text: ""
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
        },
        accessibility: {
          point: {
            valueSuffix: "%"
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            innerSize: "65%",
            cursor: "pointer",
            dataLabels: {
              enabled: false,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %"
            },
            showInLegend: true
          }
        },
        series: [
          {
            name: "Jumlah Metadata",
            colorByPoint: true,
            data: [
              {
                name: "Dasar",
                y: 33,
                color: "#2784FF",
                selected: true
              },
              {
                name: "Sektoral",
                color: "#6FCF97",
                y: 33
              },
              {
                name: "Khusus",
                color: "#F9C057",
                y: 33
              }
            ]
          }
        ],
        credits: {
          enabled: false
        },
        legend: { enabled: false }
      },
      chartPieIndOptions: {
        chart: {
          backgroundColor: "transparent",
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie"
        },
        title: {
          verticalAlign: "middle",
          floating: true,
          text: ""
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
        },
        accessibility: {
          point: {
            valueSuffix: "%"
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            innerSize: "65%",
            cursor: "pointer",
            dataLabels: {
              enabled: false,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %"
            },
            showInLegend: true
          }
        },
        series: [
          {
            name: "Jumlah Metadata",
            colorByPoint: true,
            data: [
              {
                name: "Dasar",
                y: 33,
                color: "#2784FF",
                selected: true
              },
              {
                name: "Sektoral",
                color: "#6FCF97",
                y: 33
              },
              {
                name: "Khusus",
                color: "#F9C057",
                y: 33
              }
            ]
          }
        ],
        credits: {
          enabled: false
        },
        legend: { enabled: false }
      },
      chartPieVarOptions: {
        chart: {
          backgroundColor: "transparent",
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie"
        },
        title: {
          verticalAlign: "middle",
          floating: true,
          text: ""
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
        },
        accessibility: {
          point: {
            valueSuffix: "%"
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            innerSize: "65%",
            cursor: "pointer",
            dataLabels: {
              enabled: false,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %"
            },
            showInLegend: true
          }
        },
        series: [
          {
            name: "Jumlah Metadata",
            colorByPoint: true,
            data: [
              {
                name: "Dasar",
                y: 33,
                color: "#2784FF",
                selected: true
              },
              {
                name: "Sektoral",
                color: "#6FCF97",
                y: 33
              },
              {
                name: "Khusus",
                color: "#F9C057",
                y: 33
              }
            ]
          }
        ],
        credits: {
          enabled: false
        },
        legend: { enabled: false }
      },
      total: {
        ms_keg: {
          dasar: 0,
          sektoral: 0,
          khusus: 0
        },
        ms_var: {
          dasar: 0,
          sektoral: 0,
          khusus: 0
        },
        ms_ind: {
          dasar: 0,
          sektoral: 0,
          khusus: 0
        }
      },
      user:null,
      
      
    };
  },
  
  mounted() {
    this.getUserInfo(this.$store.getters["auth/user"])
    // this.getProvinsi();
    this.setSubmissionPeriod();
    this.getProdusenDataSummary();
    this.getProdusenDataSummaryByStatus();
    this.isLoading = false;
  },
  methods: {
    getUserInfo(user){
      if (!user) return;
      const sdiOrg = user.sdiOrganization || {};
      const details = sdiOrg.details || {};
      this.user = {
        username: user.username || "",
        name : user.name || "",
        email: user.email || "",
        organization: {
          id: sdiOrg.id || null,
          name: sdiOrg.name || "",
          address: details.address || "",
          province: details.province || "",
          city: details.city || "",
        } 
      };
    },
    setSubmissionPeriod(){
      let currentYear = new Date().getFullYear();
      this.submissionPeriod = currentYear;
      this.options.submissionPeriod = this.range(2021, currentYear);
    },
    range(start, stop, step = 1){
      return Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step));
    },
    submissionPeriodChanged(period){
      this.submissionPeriod = period;
      this.getProdusenDataSummary();
      this.getProdusenDataSummaryByStatus();
    },
    
    async getProdusenDataSummary(){
      let submissionPeriod = this.submissionPeriod;
      let produsenDataId = (this.user && this.user.organization) ? this.user.organization.id : null;
      this.produsenDataSummary.isLoading = true;
      await msService.getProdusenDataSummary(submissionPeriod, produsenDataId).then(
        response =>{
          if(response && response.data){
            let rawData = response.data;
            if (rawData && Array.isArray(rawData.data)) {
              rawData = rawData.data;
            }
            if (!Array.isArray(rawData)) {
              rawData = [];
            }

            const parsePeriod = (period) => {
              if (!period) return 0;
              const str = String(period);
              if (str.includes('-')) {
                const parts = str.split('-');
                return (parseInt(parts[0], 10) || 0) * 100 + (parseInt(parts[1], 10) || 0);
              }
              return parseInt(str, 10) || 0;
            };

            let sortedData = [...rawData].sort((a, b) => parsePeriod(a.period) - parsePeriod(b.period));
            this.produsenDataSummary.data = sortedData;

            const totalKeg = sortedData.reduce((sum, item) => sum + (Number(item.total_ms_keg) || 0), 0);
            const totalVar = sortedData.reduce((sum, item) => sum + (Number(item.total_ms_var) || 0), 0);
            const totalInd = sortedData.reduce((sum, item) => sum + (Number(item.total_ms_ind) || 0), 0);

            this.produsenDataSummary.msKegChart.series = [{
              name: "Kegiatan",
              type: 'area',
              data: sortedData.map(x=>({x: String(x.period || ''), y: Number(x.total_ms_keg) || 0}))
            }];
            this.produsenDataSummary.msKegChart.options = {
              ...this.produsenDataSummary.msKegChart.options,
              title: {
                ...this.produsenDataSummary.msKegChart.options.title,
                text: totalKeg.toString()
              }
            };

            this.produsenDataSummary.msVarChart.series = [{
              name: "Variabel",
              type: 'area',
              data: sortedData.map(x=>({x: String(x.period || ''), y: Number(x.total_ms_var) || 0}))
            }];
            this.produsenDataSummary.msVarChart.options = {
              ...this.produsenDataSummary.msVarChart.options,
              title: {
                ...this.produsenDataSummary.msVarChart.options.title,
                text: totalVar.toString()
              }
            };

            this.produsenDataSummary.msIndChart.series = [{
              name: "Indikator",
              type: 'area',
              data: sortedData.map(x=>({x: String(x.period || ''), y: Number(x.total_ms_ind) || 0}))
            }];
            this.produsenDataSummary.msIndChart.options = {
              ...this.produsenDataSummary.msIndChart.options,
              title: {
                ...this.produsenDataSummary.msIndChart.options.title,
                text: totalInd.toString()
              }
            };
          }
        },
        error =>{
          console.log(error);
          this.produsenDataSummary.error = error;
        }
      );
      this.produsenDataSummary.isLoading = false;
    },
    async getProdusenDataSummaryByStatus(){
      let submissionPeriod = this.submissionPeriod;
      let produsenDataId = (this.user && this.user.organization) ? this.user.organization.id : null;
      this.produsenDataSummaryByStatus.isLoading = true;
      await msService.getProdusenDataSummaryByStatus(submissionPeriod, produsenDataId).then(
        response =>{
          let resData = response.data;
          if (resData && Array.isArray(resData.data)) {
            resData = resData.data;
          }
          this.produsenDataSummaryByStatus.data = Array.isArray(resData) ? resData[0] : (resData || []);
        },
        error =>{
          console.log(error);
          this.produsenDataSummaryByStatus.error = error;
        }
      );
      this.produsenDataSummaryByStatus.isLoading = false;
    },
    async loadMetadataStatistik(query) {
      await msService.getDashboard(query).then(
        response => {
          let pusat = response.data.result[0].filter(
            x => x.kode_provinsi == "00"
          );

          let sumPusat = {
            kode_kabupaten_kota: "0000",
            kode_provinsi: "00",
            region_code: "000000",
            year: null,
            ms_ind_dasar: 0,
            ms_ind_khusus: 0,
            ms_ind_sektoral: 0,
            ms_keg_dasar: 0,
            ms_keg_khusus: 0,
            ms_keg_sektoral: 0,
            ms_var_dasar: 0,
            ms_var_khusus: 0,
            ms_var_sektoral: 0,
            approved_dasar: 0,
            approved_khusus: 0,
            approved_sektoral: 0,
            correction_required_dasar: 0,
            correction_required_khusus: 0,
            correction_required_sektoral: 0,
            draft_dasar: 0,
            draft_khusus: 0,
            draft_sektoral: 0,
            published_dasar: 0,
            published_khusus: 0,
            published_sektoral: 0,
            rejected_dasar: 0,
            rejected_khusus: 0,
            rejected_sektoral: 0,
            revised_dasar: 0,
            revised_khusus: 0,
            revised_sektoral: 0,
            submitted_dasar: 1,
            submitted_khusus: 0,
            submitted_sektoral: 0,
            under_review_dasar: 0,
            under_review_khusus: 0,
            under_review_sektoral: 0,
            dasar_cara_lain: 0,
            dasar_kompromin: 0,
            dasar_sensus: 0,
            dasar_survei: 0,
            khusus_cara_lain: 0,
            khusus_kompromin: 0,
            khusus_sensus: 0,
            khusus_survei: 0,
            sektoral_cara_lain: 0,
            sektoral_kompromin: 0,
            sektoral_sensus: 0,
            sektoral_surve: 0
          };

          let i = 0;
          for (i; i < pusat.length; i++) {
            sumPusat.ms_keg_dasar += pusat[i].ms_keg_dasar;
            sumPusat.ms_keg_sektoral += pusat[i].ms_keg_sektoral;
            sumPusat.ms_keg_khusus += pusat[i].ms_keg_khusus;
            sumPusat.ms_var_dasar += pusat[i].ms_var_dasar;
            sumPusat.ms_var_sektoral += pusat[i].ms_var_sektoral;
            sumPusat.ms_var_khusus += pusat[i].ms_var_khusus;
            sumPusat.ms_ind_dasar += pusat[i].ms_ind_dasar;
            sumPusat.ms_ind_sektoral += pusat[i].ms_ind_sektoral;
            sumPusat.ms_ind_khusus += pusat[i].ms_ind_khusus;
            sumPusat.approved_khusus += pusat[i].approved_khusus;
            sumPusat.approved_sektoral += pusat[i].approved_sektoral;
            sumPusat.correction_required_dasar += pusat[i].correction_required_dasar;
            sumPusat.correction_required_khusus += pusat[i].correction_required_khusus;
            sumPusat.correction_required_sektoral += pusat[i].correction_required_sektoral;
            sumPusat.draft_dasar += pusat[i].draft_dasar;
            sumPusat.draft_khusus += pusat[i].draft_khusus;
            sumPusat.draft_sektoral += pusat[i].draft_sektoral;
            sumPusat.published_dasar += pusat[i].published_dasar;
            sumPusat.published_khusus += pusat[i].published_khusus;
            sumPusat.published_sektoral += pusat[i].published_sektoral;
            sumPusat.rejected_dasar += pusat[i].rejected_dasar;
            sumPusat.rejected_khusus += pusat[i].rejected_khusus;
            sumPusat.rejected_sektoral += pusat[i].rejected_sektoral;
            sumPusat.revised_dasar += pusat[i].revised_dasar;
            sumPusat.revised_khusus += pusat[i].revised_khusus;
            sumPusat.revised_sektoral += pusat[i].revised_sektoral;
            sumPusat.submitted_dasar += pusat[i].submitted_dasar;
            sumPusat.submitted_khusus += pusat[i].submitted_khusus;
            sumPusat.submitted_sektoral += pusat[i].submitted_sektoral;
            sumPusat.under_review_dasar += pusat[i].under_review_dasar;
            sumPusat.under_review_khusus += pusat[i].under_review_khusus;
            sumPusat.under_review_sektoral += pusat[i].under_review_sektoral;
            sumPusat.dasar_cara_lain += pusat[i].dasar_cara_lain;
            sumPusat.dasar_kompromin += pusat[i].dasar_kompromin;
            sumPusat.dasar_sensus += pusat[i].dasar_sensus;
            sumPusat.dasar_survei += pusat[i].dasar_survei;
            sumPusat.khusus_cara_lain += pusat[i].khusus_cara_lain;
            sumPusat.khusus_kompromin += pusat[i].khusus_kompromin;
            sumPusat.khusus_sensus += pusat[i].khusus_sensus;
            sumPusat.khusus_survei += pusat[i].khusus_survei;
            sumPusat.sektoral_cara_lain += pusat[i].sektoral_cara_lain;
            sumPusat.sektoral_kompromin += pusat[i].sektoral_kompromin;
            sumPusat.sektoral_sensus += pusat[i].sektoral_sensus;
            sumPusat.sektoral_survei += pusat[i].sektoral_survei;
          }

          if (this.provinsiSelected == null) {
            let rmPusat = response.data.result[0].filter(x => x.kode_provinsi != "00");
            this.metadataStatistik = rmPusat;
            this.metadataStatistik.push(sumPusat);
          } else {
            this.metadataStatistik = response.data.result[0];
            if (this.provinsiSelected == "00") {
              this.metadataStatistik.push(sumPusat);
            }
          }

          this.metadataStatistik.sort((a, b) => a.region_code > b.region_code? 1 : b.region_code > a.region_code ? -1 : 0);

          if (this.dashboardSelected ==1 ) {
            this.setChart(this.metadataStatistik);
          }
          this.isLoading = false;
        },
        error => {
          this.metadataStatistik =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    },
    async getProvinsi() {
      await wilayahService.getProvinsi().then(
        response => {
          this.provinsiOptions = response.data.data;
          this.provinsiOptions.push({ kode_prov: "00", nama_prov: "PUSAT" });

          let kodeWilayah = null;
          if(this.$store.getters["auth/user"].sdiOrganization){
            kodeWilayah = this.$store.getters["auth/user"].sdiOrganization.provinceCode;
          }
          if (kodeWilayah == "00") {
            this.loadMetadataStatistik(
              "metadata-statistik/1?year=" + this.tahunSelected
            );
          } else {
            let provinsi = this.provinsiOptions.filter(
              x => x.kode_prov == kodeWilayah
            );
            this.provinsiOptions = provinsi;
            this.provinsiSelected = kodeWilayah;
          }
        },
        error => {
          console.log(error);
        }
      );
    },
    async getKabupatenKota(id) {
      await wilayahService.getKabupatenKotaByProvinsi(id).then(
        response => {
          this.kabupatenKotaOptions = response.data.data;
          this.kabupatenKotaOptions.push({
            nama_kab: this.provinsiOptions.find(
              x => x.kode_prov == this.provinsiSelected
            ).nama_prov,
            kode_kab: this.provinsiSelected + "00"
          });
          this.getData();
        },
        error => {
          console.log(error);
        }
      );
    },
    getData() {
      if (this.dashboardSelected == "1") {
        if (this.provinsiSelected == null) {
          this.loadMetadataStatistik("metadata-statistik/1?year=" + this.tahunSelected);
        } else {
          this.loadMetadataStatistik("metadata-statistik/1?year=" +this.tahunSelected +"&regionCode=" +this.provinsiSelected
          );
        }
      } else if (this.dashboardSelected == "2") {
        if (this.provinsiSelected == null) {
          this.loadMetadataStatistik("metadata-statistik-kegiatan/1?year=" + this.tahunSelected);
        } else {
          this.loadMetadataStatistik("metadata-statistik-kegiatan/1?year=" +this.tahunSelected +"&regionCode=" +this.provinsiSelected);
        }
      } else if (this.dashboardSelected == "3") {
        if (this.provinsiSelected == null) {
          this.loadMetadataStatistik("metadata-statistik-variabel/1?year=" + this.tahunSelected);
        } else {
          this.loadMetadataStatistik("metadata-statistik-variabel/1?year=" + this.tahunSelected +"&regionCode=" +this.provinsiSelected);
        }
      } else if (this.dashboardSelected == "4") {
        if (this.provinsiSelected == null) {
          this.loadMetadataStatistik("metadata-statistik-indikator/1?year=" + this.tahunSelected);
        } else {
          this.loadMetadataStatistik("metadata-statistik-indikator/1?year=" + this.tahunSelected +"&regionCode=" +this.provinsiSelected);
        }
      } else if (this.dashboardSelected == "5") {
        if (this.provinsiSelected == null) {
          this.loadMetadataStatistik("metadata-statistik-kegiatan/2?year=" + this.tahunSelected);
        } else {
          this.loadMetadataStatistik("metadata-statistik-kegiatan/2?year=" +this.tahunSelected + "&regionCode=" +this.provinsiSelected);
        }
      }
    },
    setChart(data) {
      let i = 0;
      let total = {
        ms_keg: {
          dasar: 0,
          sektoral: 0,
          khusus: 0
        },
        ms_var: {
          dasar: 0,
          sektoral: 0,
          khusus: 0
        },
        ms_ind: {
          dasar: 0,
          sektoral: 0,
          khusus: 0
        }
      };
      for (i; i < data.length; i++) {
        total.ms_keg.dasar += data[i].ms_keg_dasar;
        total.ms_keg.sektoral += data[i].ms_keg_sektoral;
        total.ms_keg.khusus += data[i].ms_keg_khusus;

        total.ms_var.dasar += data[i].ms_var_dasar;
        total.ms_var.sektoral += data[i].ms_var_sektoral;
        total.ms_var.khusus += data[i].ms_var_khusus;

        total.ms_ind.dasar += data[i].ms_ind_dasar;
        total.ms_ind.sektoral += data[i].ms_ind_sektoral;
        total.ms_ind.khusus += data[i].ms_ind_khusus;
      }

      this.chartPieKegOptions.series[0].data[0].y = total.ms_keg.dasar;
      this.chartPieKegOptions.series[0].data[1].y = total.ms_keg.sektoral;
      this.chartPieKegOptions.series[0].data[2].y = total.ms_keg.khusus;
      this.chartPieKegOptions.title.text =
        total.ms_keg.dasar +
        total.ms_keg.sektoral +
        total.ms_keg.khusus +
        "<br/>Record";

      this.chartPieVarOptions.series[0].data[0].y = total.ms_var.dasar;
      this.chartPieVarOptions.series[0].data[1].y = total.ms_var.sektoral;
      this.chartPieVarOptions.series[0].data[2].y = total.ms_var.khusus;
      this.chartPieVarOptions.title.text =
        total.ms_var.dasar +
        total.ms_var.sektoral +
        total.ms_var.khusus +
        "<br/>Record";

      this.chartPieIndOptions.series[0].data[0].y = total.ms_ind.dasar;
      this.chartPieIndOptions.series[0].data[1].y = total.ms_ind.sektoral;
      this.chartPieIndOptions.series[0].data[2].y = total.ms_ind.khusus;
      this.chartPieIndOptions.title.text =
        total.ms_ind.dasar +
        total.ms_ind.sektoral +
        total.ms_ind.khusus +
        "<br/>Record";
      this.total = total;
    }
  },
  watch: {
    dashboardSelected() {
      this.metadataStatistik = [];
      this.getData();
    },
    tahunSelected() {
      this.metadataStatistik = [];
      this.getData();
    },
    provinsiSelected(val) {
      this.isLoading = true;
      this.metadataStatistik = [];
      if (this.provinsiSelected == "00") {
        this.kabupatenKotaOptions = eselon2;
        this.getData();
      } else {
        this.getKabupatenKota(val);
      }
    }
  }
};
</script>
